/**
 * Aplica o tema antes da primeira pintura.
 *
 * Módulo com efeito colateral no topo, importado como **primeira linha** de
 * `main.tsx`: ele roda na avaliação do bundle, antes de o React montar, que é
 * cedo o bastante para não haver flash perceptível.
 *
 * Por que não um `<script>` inline no HTML, como faz a operação: a CSP do
 * portal é `script-src 'self'`, sem `unsafe-inline` e sem nonce — o navegador
 * bloquearia o script e o flash aconteceria mesmo assim, com um erro no
 * console de brinde.
 *
 * A chave é `central.portal.theme`, e não `central.theme`: em produção as duas
 * origens não se veem, mas em desenvolvimento as duas rodam em `localhost` e
 * compartilhariam o `localStorage`.
 */
const CHAVE = 'central.portal.theme';

export function aplicarTema(): void {
  const guardado = localStorage.getItem(CHAVE);
  const escuro =
    guardado === 'dark' ||
    (guardado !== 'light' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  document.documentElement.classList.toggle('dark', escuro);
}

aplicarTema();
